import { s } from '@/theme/tokens';
import { Box } from '@/ui/primitives';
import type { SxProps, Theme } from '@mui/material/styles';
import type { ReactElement } from 'react';

export const CHART_EMPTY_STATE_FILTER_HINT = 'Try adjusting filters or search.';

type ChartEmptyStateProps = {
  message?: string;
  title?: string;
  body?: string;
  contentSx?: SxProps<Theme>;
  titleSx?: SxProps<Theme>;
};

export const ChartEmptyState = ({
  message = 'NO DATA',
  title,
  body,
  contentSx,
  titleSx,
}: ChartEmptyStateProps): ReactElement => {
  const resolvedContentSx: SxProps<Theme> = [
    {
      display: 'flex',
      flexDirection: 'column',
      gap: s('xxs'),
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '14px',
    },
    ...(Array.isArray(contentSx) ? contentSx : contentSx == null ? [] : [contentSx]),
  ];
  const resolvedTitleSx: SxProps<Theme> = [
    { fontWeight: 600 },
    ...(Array.isArray(titleSx) ? titleSx : titleSx == null ? [] : [titleSx]),
  ];
  if (title || body) {
    return (
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'text.secondary',
          textAlign: 'center',
        }}
      >
        <Box sx={resolvedContentSx}>
          {title ? <Box sx={resolvedTitleSx}>{title}</Box> : null}
          {body ? <Box>{body}</Box> : null}
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'text.secondary',
        fontSize: '14px',
      }}
    >
      <Box sx={{ fontWeight: 600, textTransform: 'uppercase' }}>{message}</Box>
    </Box>
  );
};
